import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 15,
			fill: "#E8112D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 11L14.8965 14.8675L11 18.7278",
			stroke: "white",
			strokeWidth: 1.60885,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1484 11L15.252 14.8675L19.1484 18.7278",
			stroke: "white",
			strokeWidth: 1.60885,
			strokeMiterlimit: 10
		})
	]
});
export default SvgBatchDelete;
